import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SyncIcon from '@mui/icons-material/Sync';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  green,
  grey,
  orange,
} from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { PartnerEnrollmentStatus } from './enums';
import { TestIds } from '../assets/testIds';

interface PartnerEnrollmentStatusBadgeProps {
  status: Exclude<PartnerEnrollmentStatus, typeof PartnerEnrollmentStatus.NotStarted>;
}

export function PartnerEnrollmentStatusBadge({
  status,
}: PartnerEnrollmentStatusBadgeProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  const config = {
    [PartnerEnrollmentStatus.ActionRequired]: {
      background: orange[50],
      border: orange[200],
      color: orange[900],
      icon: WarningAmberIcon,
      label: t('partnerDetails.enrollmentStatus.actionRequired'),
    },
    [PartnerEnrollmentStatus.InProgress]: {
      background: grey[50],
      border: grey[400],
      color: grey[800],
      icon: SyncIcon,
      label: t('partnerDetails.enrollmentStatus.inProgress'),
    },
    [PartnerEnrollmentStatus.Completed]: {
      background: green[50],
      border: green[200],
      color: green[800],
      icon: CheckCircleOutlineIcon,
      label: t('partnerDetails.enrollmentStatus.earningRewards'),
    },
  }[status];
  const StatusIcon = config.icon;

  return (
    <Box
      data-testid={`${TestIds.partnerDetailsPage.enrollmentStatusBadgePrefix}-${status}`}
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
        color: config.color,
        backgroundColor: config.background,
        border: `1px solid ${config.border}`,
        borderRadius: theme.spacing(0.75),
      }}
    >
      <StatusIcon sx={{ width: theme.spacing(2), height: theme.spacing(2) }} />
      <Typography variant="h10" color="inherit">
        {config.label}
      </Typography>
    </Box>
  );
}
